module.exports = __webpack_public_path__ + "img/pick4.8cfe3aff.png";